import { useId } from "react";
import { Divider, Icon, List, ListItem, Stack, Text } from "@bookingcom/bui-react";
import { CheckmarkFillIcon } from "@bookingcom/bui-assets-react/streamline";
import styles from "../CampaignImpact.module.css";

type PeriodOptionGroup = {
  label: string;
  options: { value: string; text: string }[];
};

type PeriodPickerContentProps = {
  period: string;
  periodOptionGroups: PeriodOptionGroup[];
  onPeriodChange: (period: string) => void;
};

export const PeriodPickerContent = ({ period, periodOptionGroups, onPeriodChange }: PeriodPickerContentProps) => {
  const baseId = useId();

  return (
    <Stack
      direction="column"
      gap={0}
      className={styles.periodPickerContentContainer}
      attributes={{ "aria-label": "Period select menu" }}
    >
      {periodOptionGroups.map((group, groupIndex) => (
        <Stack
          key={group.label}
          direction="column"
          gap={0}
          attributes={{ role: "group", "aria-labelledby": `${baseId}-group-${groupIndex}` }}
        >
          {groupIndex > 0 && <Divider />}
          <Text
            variant="emphasized_2"
            color="disabled"
            mixin={{ padding: 3 }}
            attributes={{ id: `${baseId}-group-${groupIndex}` }}
          >
            {group.label}
          </Text>
          <List>
            {group.options.map(({ value, text }) => (
              <ListItem
                key={`kPeriodPickerContentListItem-${value}`}
                spacing="small"
                onClick={() => onPeriodChange(value)}
                className={styles.periodPickerContentListItem}
                aria-selected={period === value}
              >
                <Stack direction="row" alignItems="center" gap={2}>
                  <Text>{text}</Text>
                  {period === value && <Icon svg={CheckmarkFillIcon} />}
                </Stack>
              </ListItem>
            ))}
          </List>
        </Stack>
      ))}
    </Stack>
  );
};
